import { Config, SettingsConfig } from "./configType";

export const fgfSettings: SettingsConfig = {
  runConfiguration: process.env.REACT_APP_ENVIRONMENT,
  apiManagement: process.env.REACT_APP_FGF_APIM,
  ocpApimSubscriptionKey: process.env.REACT_APP_FGF_APIM_KEY,
  googleApiKey: process.env.REACT_APP_FGF_GOOGLE_API_KEY,
  leadMarketAffiliateCode: process.env.REACT_APP_FGF_LEAD_MARKET_AFFILIATE_CODE,
  leadMarketMode: process.env.REACT_APP_FGF_LEAD_MARKET_MODE,
  bankStatementIframeUrl: process.env.REACT_APP_FGF_BANK_STATEMENTS_IFRAME,
  shouldUseAsyncQueue: process.env.REACT_APP_FGF_SHOULD_USE_ASYNC_QUEUE,
  portalUrl: process.env.REACT_APP_FGF_PORTAL_URL,
  privacyPolicyPageFSA: process.env.REACT_APP_FSA_PRIVACY_POLICY,
  contentManagementUrl: process.env.REACT_APP_FGF_CDS_URL,
  contentToken: process.env.REACT_APP_FGF_CDS_TOKEN,
  trustPilotDataId: process.env.REACT_APP_FGF_TRUST_PILOT_DATA_ID,
  trustPilotBusinessUnit: process.env.REACT_APP_FGF_TRUST_PILOT_BUSINESS_UNIT,
  trustPilotURL: process.env.REACT_APP_FGF_TRUST_PILOT_URL,
  gtmId: process.env.REACT_APP_FGF_GTM_ID,
  gtmAuth: process.env.REACT_APP_FGF_GTM_AUTH,
  gtmPreview: process.env.REACT_APP_FGF_GTM_PREVIEW,
  useChatbot: process.env.REACT_APP_FGF_USE_CHATBOT,
  phone: process.env.REACT_APP_FGF_PHONE,
  email: process.env.REACT_APP_FGF_EMAIL,
  applyEmail: process.env.REACT_APP_FGF_APPLY_EMAIL,
  abn: process.env.REACT_APP_FGF_ACN,
  acl: process.env.REACT_APP_FGF_ACL,
  faq: process.env.REACT_APP_FGF_FAQ,
  companyName: process.env.REACT_APP_FGF_COMPANY_NAME,
  termsAndConditions: process.env.REACT_APP_FGF_TERMS_AND_CONDITIONS,
  privacy: process.env.REACT_APP_FGF_PRIVACY_POLICY,
  cdsApp: process.env.REACT_APP_FGF_CDS_APP,
  privacyConsentAndElectronicAuthorisation: process.env.REACT_APP_FGF_PRIVACY_CONSENT_AND_ELECTRONIC_AUTHORISATION,
  creditGuide: process.env.REACT_APP_FGF_CREDIT_GUIDE,
  salesforceBeaconScript: process.env.REACT_APP_FGF_SALESFORCE_BEACON_SCRIPT,
};

export const fgfConfig: Config = {
  partnerLogo: 'fairgo-partnership-logo.svg',
  sharedPrivacyConsent: 'SHARING INFORMATION WITHIN OUR GROUP OF COMPANIES: To my personal, sensitive and credit information being shared with Fair Go Finance\'s related bodies corporate, including Fintech Services (Aust) Pty Ltd  and Nimble Australia Pty Ltd.',
  sharedReportingConsent: 'To, and acknowledge that, my application may be notified to a credit reporting body, and I understand that even if I do not enter into a credit contract with Fair Go Finance, this may affect the decision of another lender to provide me with credit and the terms on which credit is offered.',
  declinePageContent: "",
};

export const fgfFavicon = '/favicon-fgf.png';